export default "__VITE_ASSET__J7zQL59Q__"